import React from "react";
import authReducer from "../reducers/auth";
import { auth, requestState } from "../actions";
import axios from "axios";
import setAuthToken from "../../utils/setAuthToken";
import CouponCodeGenerator from "crypto-random-string";
const AuthContext = React.createContext();
export const AuthProvider = ({ children }) => {
	const initialState = {
		token: localStorage.getItem("token"),
		isAuthenticated: false,
		loading: false,
		error: null,
		userAuthenticated: JSON.parse(localStorage.getItem('user')),
		success: null,
	};

	const [authState, dispatch] = React.useReducer(authReducer, initialState);

	const isLoading = () => {
		dispatch({
			type: requestState.LOADING,
		});
	};

	//Load user
	const loadUser = async () => {
		setAuthToken(localStorage.token);
		try {
			const res = await axios.get("/auth");
			checkUserReferral(res.data);
			dispatch({
				type: requestState.LOADED,
				payload: res.data,
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : "Connection failed" || error.message,
			});
		}
	};

	//Load user
	const updateProfile = async (_id, data) => {
		isLoading();
		try {
			const res = await axios.put(`/user/${_id}`, data);
			dispatch({
				type: auth.UPDATE_PROFIL,
				payload: res.data,
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message :  error.message,
			});
		}
	};

	const checkUserReferral = async (user) => {
		try {
			if (!user.hasReferral) {
				const data = {
					user: user._id,
					code: CouponCodeGenerator({ length: 6, type: "distinguishable" }),
				};
				 await axios.post(`/referrals`, data);
				//console.log(referral.data);
			} else {
				console.log("user has referral");
			}
		} catch (error) {
			console.log(error);
		}
	};
	// Logout
	const logout = async () => {
		dispatch({
			type: auth.LOGOUT,
		});
	};

	// Clear Errors
	const clearNotification = () =>
		dispatch({
			type: requestState.CLEAR_NOTIFICATION,
		});
	return (
		<AuthContext.Provider
			value={{
				token: authState.token,
				isAuthenticated: authState.isAuthenticated,
				loading: authState.loading,
				error: authState.error,
				userAuthenticated: authState.userAuthenticated,
				loadUser: loadUser,
				logout: logout,
				clearNotification: clearNotification,
				isLoading: isLoading,
				success: authState.success,
				updateProfile: updateProfile,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};

export const useAuthContext = () => React.useContext(AuthContext);
